import React from "react";
import CarWash from "../Icons/CarWashIcon";
import Cctv from "../Icons/CctvIcon";
import DisabledAccess from "../Icons/DisabledAccessIcon";
import EvCharging from "../Icons/EvChargingIcon";
import KeyFob from "../Icons/KeyFobIcon";
import Lighting from "../Icons/LightingIcon";
import Permit from "../Icons/PermitIcon";
import SecurityGuards from "../Icons/SecurityGuardsIcon";
import Toilets from "../Icons/ToiletsIcon";
import Transfers from "../Icons/TransfersIcon";
import Gated from "../Icons/GatedIcon";
import High from "../Icons/HighIcon";
import Low from "../Icons/LowIcon";
import Narrow from "../Icons/NarrowIcon";
import Sheltered from "../Icons/ShelteredIcon";
import Underground from "../Icons/UnderGroundIcon";
import Wide from "../Icons/WideIcon";
import SecurityCode from "../Icons/SecurityCodeIcon";
import SingleEntry from "../Icons/SingleEntryIcon";
import ParkAndRide from "../Icons/ParkAndRideIcon";
import AllowsOvernight from "../Icons/AllowsOvernightIcon";
import TwentyFourSeven from "../qicons/TwentyFourSeven";

type Props = {
  iconName:
    | "has_carwash"
    | "has_cctv"
    | "has_disabled_access"
    | "has_ev_charging"
    | "has_keyfob"
    | "has_lighting"
    | "has_permit"
    | "has_security_guards"
    | "has_toilets"
    | "has_transfers"
    | "is_gated"
    | "is_high"
    | "is_low"
    | "is_narrow"
    | "is_sheltered"
    | "is_underground"
    | "is_wide"
    | "security_code"
    | "single_entry"
    | "park_and_ride"
    | "allows_overnight"
    | "has_24x7_access"
};

const FacilitiesIcon = ({ iconName }: Props) => {
  switch (iconName) {
    case "has_carwash":
      return <CarWash />;
    case "has_cctv":
      return <Cctv />;
    case "has_disabled_access":
      return <DisabledAccess />;
    case "has_ev_charging":
      return <EvCharging />;
    case "has_keyfob":
      return <KeyFob />;
    case "has_lighting":
      return <Lighting />;
    case "has_permit":
      return <Permit />;
    case "has_security_guards":
      return <SecurityGuards />;
    case "has_toilets":
      return <Toilets />;
    case "has_transfers":
      return <Transfers />;
    case "is_gated":
      return <Gated />;
    case "is_high":
      return <High />;
    case "is_low":
      return <Low />;
    case "is_narrow":
      return <Narrow />;
    case "is_sheltered":
      return <Sheltered />;
    case "is_underground":
      return <Underground />;
    case "is_wide":
      return <Wide />;
    case "park_and_ride":
      return <ParkAndRide />;
    case "security_code":
      return <SecurityCode />;
    case "single_entry":
      return <SingleEntry />;
    case "allows_overnight":
      return <AllowsOvernight />;
    case "has_24x7_access":
      return <TwentyFourSeven />;
    default:
      return null;
  }
};

export default FacilitiesIcon;
